import { render } from "./taskgroupCreate.vue?vue&type=template&id=0e5ec25e&scoped=true"
import script from "./taskgroupCreate.vue?vue&type=script&lang=js"
export * from "./taskgroupCreate.vue?vue&type=script&lang=js"

import "./taskgroupCreate.vue?vue&type=style&index=0&id=0e5ec25e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5ec25e"]])

export default __exports__